import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

import './PlayerNames.css';
import PlayerName from '../../components/PlayerName/PlayerName';
import Button from '../../components/Button/Button';
import { handleHomeClick, playSound } from '../../utils/utils';
import WarpLink from '../../components/WarpTransition/WarpLink';

const PlayerNames = (props) => {
  window.scrollTo(0, 0);

  const {
    playerNamesState,
    updatePlayerName,
    deletePlayer,
    addPlayer,
    isNameFormValid,
  } = props;

  const handleAddPlayer = () => {
    playSound('/sounds/whoosh-transition-sound.mp3');
    addPlayer();
  };

  const handleStartGameClick = () => {
    playSound('/sounds/large-underwater-explosion-sound.mp3');
    playSound('/sounds/welcome-to-single-player.mp3');
  };

  const players = playerNamesState.map((player) => {
    const { name } = player;

    return (
      <AnimatePresence>
        <motion.li
          key={player.id}
          initial={{
            opacity: 0,
            y: -50,
            height: 0,
          }}
          animate={{ opacity: 1, y: 0, height: 'auto' }}
          exit={{ opacity: 0, y: 50, height: 0 }}
          transition={{
            duration: 0.75,
            ease: 'easeIn',
          }}
        >
          <PlayerName
            key={player.id}
            name={name}
            id={player.id}
            handleChange={updatePlayerName}
            handleDelete={deletePlayer}
            numberOfPlayers={playerNamesState.length}
          />
        </motion.li>
      </AnimatePresence>
    );
  });

  return (
    <div className="playerNames">
      <Link to="/">
        <div className="header">
          <Button
            title="home"
            type="smallSquare home"
            handleClick={handleHomeClick}
          />
        </div>
      </Link>
      <p className="multiPlayerTitle">choose plAyer nAmes</p>
      <div className="multiPlayerNames">
        <ul className="multiPlayerNamesList">{players}</ul>
        {playerNamesState.length < 12 && (
          <Button
            title="Add plAyer"
            type="smallSquare addPlayer"
            handleClick={handleAddPlayer}
          />
        )}
        <WarpLink
          to="/multi/pre-roll"
          label="ARENA SYSTEM ONLINE"
          variant="roll"
        >
          <Button
            title="stArt GAme"
            type="smallSquare startGame"
            disabled={!isNameFormValid}
            handleClick={handleStartGameClick}
          />
        </WarpLink>
        {!isNameFormValid && (
          <p className="invalidNameFormMessage">
            Error: All players need a name.
          </p>
        )}
      </div>
    </div>
  );
};

export default PlayerNames;
